<template>
  <div>
    <div v-if="hasError && errorMessage" :class="$style.formError">
      <aw-notification
        :id="rowUniqueId"
        :notifications="notifications"
        :close-after="0"
        live-region="assertive"
        @remove-notification="$event => delete notifications[$event]"
      />
    </div>
  </div>
</template>

<script>
  import { defineAsyncComponent } from 'vue';
  import { useNuxtApp } from 'nuxt/app';
  import { getFormRowErrorMessage } from '~~/common/utils/form';
  import formMixin from '~~/common/mixins/formMixin';

  export default {
    name: 'AwFormErrorNotification',
    components: {
      AwNotification: defineAsyncComponent(() => import('~~/common/components/Common/AwNotification')),
    },
    mixins: [formMixin],
    data () {
      return {
        notifications: {},
      };
    },
    computed: {
      errorMessage () {
        return this.getErrorMessage();
      },
    },
    methods: {
      getErrorMessage () {
        const msg = getFormRowErrorMessage(
          useNuxtApp(),
          this.rowValidator,
          this.modelValue.tokens,
        );
        if (msg !== undefined) {
          this.notifications = {
            0: {
              type: 'error',
              manualClose: false,
              text: {
                subtitleToken: msg,
              },
            },
          };
        }
        return msg;
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.formError {
  font-size: 12px;
  line-height: 16px;
  position: relative;
  margin-top: 12px;
  color: $color-error-v2-text;
}
</style>
